/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AppointmentBookingFailure } from './AppointmentBookingFailure';
import {
    AppointmentBookingFailureFromJSON,
    AppointmentBookingFailureFromJSONTyped,
    AppointmentBookingFailureToJSON,
    AppointmentBookingFailureToJSONTyped,
} from './AppointmentBookingFailure';
import type { AppointmentBookingSuccess } from './AppointmentBookingSuccess';
import {
    AppointmentBookingSuccessFromJSON,
    AppointmentBookingSuccessFromJSONTyped,
    AppointmentBookingSuccessToJSON,
    AppointmentBookingSuccessToJSONTyped,
} from './AppointmentBookingSuccess';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface BulkAppointmentBookingResponse
 */
export interface BulkAppointmentBookingResponse {
    /**
     * 
     * @type {Array<AppointmentBookingSuccess>}
     * @memberof BulkAppointmentBookingResponse
     */
    created?: Array<AppointmentBookingSuccess>;
    /**
     * 
     * @type {Array<AppointmentBookingFailure>}
     * @memberof BulkAppointmentBookingResponse
     */
    failed?: Array<AppointmentBookingFailure>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BulkAppointmentBookingResponse
     */
    totalRequested?: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the BulkAppointmentBookingResponse interface.
 */
export function instanceOfBulkAppointmentBookingResponse(value: object): value is BulkAppointmentBookingResponse {
    return true;
}

export function BulkAppointmentBookingResponseFromJSON(json: any): BulkAppointmentBookingResponse {
    return BulkAppointmentBookingResponseFromJSONTyped(json, false);
}

export function BulkAppointmentBookingResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkAppointmentBookingResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'created': json['created'] == null ? undefined : ((json['created'] as Array<any>).map(AppointmentBookingSuccessFromJSON)),
        'failed': json['failed'] == null ? undefined : ((json['failed'] as Array<any>).map(AppointmentBookingFailureFromJSON)),
        'totalRequested': json['totalRequested'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalRequested']),
    };
}

export function BulkAppointmentBookingResponseToJSON(json: any): BulkAppointmentBookingResponse {
    return BulkAppointmentBookingResponseToJSONTyped(json, false);
}

export function BulkAppointmentBookingResponseToJSONTyped(value?: BulkAppointmentBookingResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'created': value['created'] == null ? undefined : ((value['created'] as Array<any>).map(AppointmentBookingSuccessToJSON)),
        'failed': value['failed'] == null ? undefined : ((value['failed'] as Array<any>).map(AppointmentBookingFailureToJSON)),
        'totalRequested': ApiUserTasksGetPageParameterToJSON(value['totalRequested']),
    };
}

